import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getEndpointAI } from "../../../../../abstract/redux/slice/endpointSlice";
import { createSendMessageToAPI, isValidYAML } from "../utils/AiUtils";

export const useMessageHandler = (setIsLoading, onAiResponse, setMessages) => {
  const _sendMessageToAPIRef = useRef();
  const _endpointAI = useSelector(getEndpointAI);

  useEffect(() => {
    _sendMessageToAPIRef.current = createSendMessageToAPI(
      setIsLoading,
      `${_endpointAI}/ai`,
      setMessages
    );
  }, [_endpointAI, setIsLoading, setMessages]);

  const sendMessageToAPI = useCallback((message, files = null) => {
    return _sendMessageToAPIRef.current(message, files);
  }, []);

  const onSendMessage = useCallback(
    (userMessage, botResponse) => {
      if (!botResponse) return;

      const apiModel =  botResponse.model ?? null;

      if (apiModel && isValidYAML(apiModel)) {
        if (onAiResponse) {
          onAiResponse(apiModel);
        }
      }
    },
    [onAiResponse]
  );

  return {
    sendMessageToAPI,
    onSendMessage,
  };
};
